import { Button, ModalDialog, ModalDialogActions, ModalDialogBody } from '@cimpress-ui/react';

export const RoutingModal = ({
  modalHeaderText,
  showModal,
  closeModal,
  testId,
  children,
}: {
  modalHeaderText: string;
  showModal?: boolean;
  closeModal?: () => void;
  testId?: string;
  children: React.ReactNode;
}) => {
  return (
    <ModalDialog
      isOpen={!!showModal}
      onOpenChange={(isOpen) => (!isOpen ? closeModal && closeModal() : undefined)}
      size="large"
      title={modalHeaderText}
      data-testid={testId}
    >
      {({ close }) => (
        <>
          <ModalDialogBody>{children}</ModalDialogBody>
          <ModalDialogActions>
            <Button variant="secondary" onPress={closeModal || close}>
              Close
            </Button>
          </ModalDialogActions>
        </>
      )}
    </ModalDialog>
  );
};
